// extracted by mini-css-extract-plugin
export var originalPrice = "_vc-0";